import React from 'react';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { ConnectPhoneMockup } from '../mockups/ConnectPhoneMockup';
export function ConnectPhoneSlide() {
  return <StepSlide step={4} title="Connect your phone" visual={<ConnectPhoneMockup data-id="element-211" data-mp="cwb5kpkou7zw" />} visualLabel="A QR code on the computer screen being scanned by an authenticator app that shows a 6-digit number" data-id="element-210" data-mp="hve9g6oxm86a">
      <p className="font-body text-[1.35cqw] leading-[1.4] text-mm-muted-charcoal" data-id="element-212" data-mp="rrr5hb7y8y47">
        Stripe now shows a <strong className="text-mm-black" data-id="element-213" data-mp="mtz13hq4bjj4">square black-and-white pattern</strong>{' '}
        (a "QR code") on your computer. It's private, so the picture is just an example.
      </p>
      <StepList size="compact" items={[<>Open the authenticator app on your phone.</>, <>
            Tap the <strong data-id="element-215" data-mp="1ahgvzm4oixqb">+</strong> button, then <strong data-id="element-216" data-mp="15l8lim1ffsph">"Scan a QR code"</strong>.
          </>, <>Point your camera at the square pattern. The app adds Stripe by itself.</>, <>
            The app shows a <strong data-id="element-217" data-mp="1drq3dogo7ab7">6-digit number</strong>. It changes every 30 seconds.
            That's normal.
          </>, <>Type that number into the box on the Stripe page.</>, <>
            Click <strong data-id="element-218" data-mp="1msfvoi6q2ik6">Continue</strong>.
          </>]} data-id="element-214" data-mp="wlbsy9bx29p5" />
    </StepSlide>;
}